import React, { Component } from 'react';
import '@zippytech/react-toolkit/Accordion/index.css';

import ContentDetail from './ContentDetail'


class IndexResourcePane extends Component {
    constructor(props) {
        super(props);
        this.state = {
            transactionTime: 300,
            transitioinFunction: 'linear'
        }
    }
    render() {
        return (
            this.props.resourcePaneFlag === "ContentDetail" ?
                <ContentDetail {...this.props} /> : null
        )
    }
}

export default IndexResourcePane;